import React, { useCallback, useContext } from 'react';
import usePopup from 'hooks/usePopup';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import EntityForm from './EntityForm';
import { Option } from '../../../kingpin/atoms/ContextMenu';
import ContextMenuContext from '../../../kingpin/atoms/ContextMenu/ContextMenuContext';

const EntitySettingsOption = ({
  entity,
  isAccessOnly,
}: {
  entity: EntityDetails.Entity;
  isAccessOnly?: boolean;
}) => {
  const { closeMenu } = useContext(ContextMenuContext);
  const { isOpen, open, close } = usePopup();
  const onClose = useCallback(() => {
    close();
    closeMenu();
  }, [close, closeMenu]);

  return (
    <>
      <Option
        label={'Settings'}
        onClick={open}
        testId={`edit-${entity.id}`}
        shouldHideInsteadOfCloseMenu
      />
      <ModalTransition>
        {isOpen && (
          <Modal
            shouldScrollInViewport={false}
            autoFocus={false}
            onClose={onClose}
          >
            <EntityForm
              entity={entity}
              close={onClose}
              isAccessOnly={isAccessOnly}
            />
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default EntitySettingsOption;
